import { render, staticRenderFns } from "./CurrencySwitcher.vue?vue&type=template&id=79bc5d8a&"
import script from "./CurrencySwitcher.vue?vue&type=script&lang=js&"
export * from "./CurrencySwitcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports